// frontend/src/pages/MaintenancePage.tsx
import React from 'react';
import { ShieldAlert } from 'lucide-react';

interface MaintenancePageProps {
  message?: string | null;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ message }) => {
  const defaultMessage = "Our site is currently undergoing scheduled maintenance. We expect to be back online shortly. Thank you for your patience.";
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground p-6 text-center">
      <ShieldAlert className="h-24 w-24 text-primary mb-8" />
      <h1 className="text-4xl font-bold mb-4">Site Under Maintenance</h1>
      <p className="text-lg text-muted-foreground max-w-xl">
        {message || defaultMessage}
      </p>
      {/* You could add a company logo or contact information here if desired */}
    </div>
  );
};

export default MaintenancePage;